import downButton from "./down-button.png"

export default { 
    downButton
}